export default __webpack_public_path__ + "static/media/cw-d1.8604cee4.jpg";